export default "__VITE_ASSET__CHTFLwkj__"